module.exports = __webpack_public_path__ + "application/templates/upload-image-preview/upload-image-preview.template.html";